import { useMemo } from 'react';

import { TTemplate } from '@wp-block-builder/package';
import useThrottledValue from '@wp-react/hooks/useThrottledValue';

import { useDocumentStoreContext } from './context';
import getCustomColors from './helpers/getCustomColors';

function getColors(v: null | undefined | TTemplate) {
  return v ? getCustomColors(v) : [];
}

export default function useDocumentColors(): string[] {
  const { configuration, layoutConfiguration } = useDocumentStoreContext();

  const internalConfiguration = useThrottledValue(configuration, 1000);
  const internalLayoutConfiguration = useThrottledValue(layoutConfiguration, 1000);
  return useMemo(() => {
    const c = getColors(internalConfiguration);
    const l = getColors(internalLayoutConfiguration);
    return [...new Set([...c, ...l])].sort();
  }, [internalConfiguration, internalLayoutConfiguration]);
}
